// extracted by mini-css-extract-plugin
export default {"XL":"index-module--XL--10b11","L":"index-module--L--d7ba5","M":"index-module--M--d029a","S":"index-module--S--28fa2","XS":"index-module--XS--99d46"};